// extracted by mini-css-extract-plugin
module.exports = {"onHover":"FadeInComponent-moduleonHover1I-","inAnimation":"FadeInComponent-moduleinAnimation1rQ"};